import { AppThunk } from '../../../store/rootReducer';
import { getBaseProperties, track } from '../analytics.utils';
import { IMPORT_DELINEATION } from '../analytics.constants';
import { DelineationSource } from '../types/analytics.types';
import { selectedDelineationSelector } from '../../delineation/selectors/delineation.selectors';

export const trackImportDelineation =
  (source: DelineationSource, analyticsEventTrack = track): AppThunk =>
  (_, getState) => {
    const importedDelineation = selectedDelineationSelector(getState());
    const baseProperties = getBaseProperties(getState);
    if (baseProperties == null || importedDelineation == null) {
      return null;
    }
    const { ecgId, userId, view } = baseProperties;

    analyticsEventTrack({
      name: IMPORT_DELINEATION,
      properties: {
        user_id: userId,
        ecg_id: ecgId,
        view,
        imported_delineation: importedDelineation?.expertName,
        source,
      },
    });
  };
